import { render } from "./Sales-Execs-Details.vue?vue&type=template&id=02491d8f&scoped=true"
import script from "./Sales-Execs-Details.vue?vue&type=script&lang=js"
export * from "./Sales-Execs-Details.vue?vue&type=script&lang=js"

import "./Sales-Execs-Details.vue?vue&type=style&index=0&id=02491d8f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\AbdullahiIsmail\\OneDrive - SWWIPE FINACIAL SERVICES\\Documents\\Automation-tool\\auto-portalV2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02491d8f"]])

export default __exports__